




































































































import Vue from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import Loading from "../general/Loading.vue";
import HolidaysBookingDetails from "../holidays/HolidaysBookingDetails.vue";

import HolidayProgramJson from "../../shared/HolidayProgramJson";
import HolidayProgramWithBookingsJson from "../../shared/HolidayProgramJson";
import HolidayProgramWithBookingJson from "../../shared/HolidayProgramJson";

import { UserPermissionRank } from "../../shared/UserPermissionRank";

export default Vue.extend({
  name: "HolidaysRequests",
  components: {
    Loading,
    HolidaysBookingDetails,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    appFrameClickedButton: Object,
    HolidayProgramBookingStatusNames: Object,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      UserPermissionRank: UserPermissionRank,
      showDetails: false,
      detailsMode: "read",
      allHolidayPrograms: null as HolidayProgramJson[] | null,
      selectedHolidayProgramBookings: null as HolidayProgramWithBookingsJson | null,
      selectedHolidayProgramId: null as number | null,
      selectedHolidayBookingId: null as number | null,
    };
  },
  created() {
    this.$emit("showAppFrameButtons", { reload: true });
    this.loadData();
  },
  methods: {
    /*** START: details view ***/
    toggleDetails: function () {
      this.showDetails = !this.showDetails;
      if (this.showDetails == false) {
        this.reloadData();
      }
    },

    openDetails(item: HolidayProgramWithBookingJson | null, mode: string) {
      if (this.selectedHolidayProgramId != null) {
        if (item != null) {
          this.selectedHolidayBookingId = item.ID;
        } else {
          this.selectedHolidayBookingId = null;
        }

        this.detailsMode = mode;
        this.toggleDetails();
      } else {
        alert("Es muss zuerst ein Programm ausgewählt werden.");
      }
    },
    /*** END: details view ***/

    loadData() {
      this.loadAllHolidayPrograms();
    },

    async loadAllHolidayPrograms() {
      this.allHolidayPrograms = null;
      this.selectedHolidayProgramId = null;
      this.selectedHolidayBookingId = null;
      this.selectedHolidayProgramBookings = null;

      if (this.restClient != null) {
        try {
          this.allHolidayPrograms = await this.restClient.getHolidayPrograms();
        } catch (e) {
          alert(e.message);
        }
      }
    },

    async loadSelectedHolidayProgramBookings() {
      if (this.allHolidayPrograms != null) {
        this.selectedHolidayProgramBookings = null;

        if (this.restClient != null && this.selectedHolidayProgramId != null) {
          try {
            this.selectedHolidayProgramBookings = await this.restClient.getHolidayProgramWithBookings(
              this.selectedHolidayProgramId
            );
          } catch (e) {
            alert(e.message);
          }
        }
      }
    },

    async reloadData() {
      this.loadSelectedHolidayProgramBookings();
    },
  },
  watch: {
    appFrameClickedButton: function () {
      if (this.appFrameClickedButton.reload) {
        this.loadData();
      }
    },
  },
  computed: {
    permissionAbleManagement: function () {
      if (this.loginPermission >= this.UserPermissionRank.management) {
        return true;
      } else {
        return false;
      }
    },
  },
});
